'use es6';

import { formatToReferencesList } from '../lib/formatReferences';
import { fromJS } from 'immutable';
import get from 'transmute/get';
import indexBy from 'transmute/indexBy';
import pipe from 'transmute/pipe';
export default pipe(fromJS, formatToReferencesList({
  getId: get('name'),
  getLabel: get('label')
}), indexBy(get('id')));